import React, { useEffect, useState } from "react";

export default function PodcastPage() {
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/podcast/rss`)
      .then(r => r.json())
      .then(d => setEpisodes(d.items || []))
      .catch(() => setEpisodes([]));
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Pod Habeas Cripto</h1>

      <div className="flex justify-between items-center mb-4">
        <p className="opacity-80">Ouça os episódios mais recentes.</p>
        <a
          className="inline-block px-4 py-2 rounded-md border hover:bg-black hover:text-white transition"
          href="https://open.spotify.com/show/0lay6R47VqnkfeagsiH2jV"
          target="_blank" rel="noreferrer"
        >
          Ouvir no Spotify
        </a>
      </div>

      <ul className="space-y-4">
        {episodes.map((e) => (
          <li key={e.id} className="p-4 rounded-lg border">
            <div className="font-semibold">{e.title}</div>
            <div className="text-sm opacity-80 mb-2">{e.description}</div>
            {e.audio_url && <audio controls src={e.audio_url} className="w-full" />}
          </li>
        ))}
        {episodes.length === 0 && <li className="opacity-70">Carregando episódios...</li>}
      </ul>
    </div>
  );
}